import { isBoolean } from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function couldBeBoolean(v?: any): v is boolean | 'true' | 'false' | '0' | '1' {
  return isBoolean(v) || v === 'true' || v === 'false' || v === '0' || v === '1';
}
